import React from "react";
import { lazy, Suspense } from "react";
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import { Provider } from "react-redux";
import { Router } from "react-router-dom";
import { Route, Switch } from "react-router-dom";
import configureStore from "./configureStore";
import throttle from "lodash/throttle";
import history from "./history";
import { saveState } from "./localStorage";
import { ContextProvider } from "../shells/contextProvider";
import LoadingComponent from "../shells/LoadingComponent/index";
const store = configureStore(history);
const Rewards = lazy(() => import("../shells/Rewards/index"));
const Rules = lazy(() => import("../shells/Rules/index"));
const MatchInfo = lazy(() => import("../shells/MatchInfo/index"));
const LeaderBoard = lazy(() => import("../shells/Leaderboard/index"));
const HistoryLeaderBoard = lazy(() =>
  import("../shells/HistoryLeaderboard/index")
);
const EarnPoints = lazy(() => import("../shells/EarnPoints/index"));
const OldLeaderboard = lazy(() => import("../shells/oldLeaderboard/index"));
const RewardOpening = lazy(() => import("../shells/RewardOpening/index"));
const Prizes = lazy(() => import("../shells/Prizes/index"));
const WeeksPrizes = lazy(() => import("../shells/WeeksPrizes/index"));
const HelpSection = lazy(() => import("../shells/HelpSection/index"));
const Demo = lazy(() => import("../shells/Rewards/Demo"));
const WebLaunch = lazy(() => import("../shells/Leaderboard/WebLunch"));
const ContestFormat = lazy(() => import("../shells/Rules/contestFormat"));

Sentry.init({
  integrations: [
    new Integrations.BrowserTracing({
      // Can also use reactRouterV3Instrumentation or reactRouterV4Instrumentation
      routingInstrumentation: Sentry.reactRouterV5Instrumentation(history),
    }),
  ],

  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 0.1,
});

store.subscribe(
  throttle(() => {
    saveState(store.getState());
  }, 1000)
);
const Root = () => (
  <ContextProvider>
    <Provider store={store}>
      <Router history={history}>
        <Suspense fallback={<LoadingComponent />}>
          <Switch>
            <LoadingComponent>
              <Route exact path="/" component={Rewards} />
              <Route exact path="/rewards" component={Rewards} />
              <Route path="/demo" component={Demo} />
              <Route path="/rules" component={Rules} />
              <Route path="/matchInfo" component={MatchInfo} />
              <Route path="/contestFormat" component={ContestFormat} />
              <Route path="/webdemo" component={WebLaunch} />
              <Route path="/active" component={LeaderBoard} />
              <Route path="/history" component={HistoryLeaderBoard} />
              <Route exact path="/earnpoints" component={EarnPoints} />
              <Route exact path="/rewardopening" component={RewardOpening} />
              <Route path="/oldleaderboard" component={OldLeaderboard} />
              <Route path="/prizes" component={Prizes} />
              <Route path="/lbprizes" component={WeeksPrizes} />
              <Route path="/help" component={HelpSection} />
            </LoadingComponent>
            {/* <AuthCheck>
          <ErrorComponent>
            <LoadingComponent>
              <Route path="/profile" component={Profile} />
             
            </LoadingComponent>
          </ErrorComponent>
        </AuthCheck> */}
          </Switch>
        </Suspense>
      </Router>
    </Provider>
  </ContextProvider>
);

export default Root;



// WEBPACK FOOTER //
// ./src/root/index.js